import { createClient } from "@sanity/client";

export const client = createClient({
  projectId: "4afi23a8",
  dataset: "production",
  apiVersion: "2023-06-03",
  useCdn: true,
});
